import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import Layout from '@Templates/Layout';
import ErrorPageImage from 'Assets/Images/img_error_page.png';
import Button from '../Button';
import TX from '../Text';

const NotFound = () => {
  return (
    <Layout>
      <FallbackContainer>
        <ErrorImage />
        <Title>앗! 없는 페이지입니다.</Title>
        <LinkButtonWrapper to="/">
          <Button text="홈으로 돌아가기" />
        </LinkButtonWrapper>
      </FallbackContainer>
    </Layout>
  );
};

const FallbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;

  align-items: center;
  justify-content: center;
`;

const ErrorImage = styled.img.attrs({
  src: ErrorPageImage,
  alt: '에러',
})`
  width: 236px;
  height: 170px;
  -webkit-user-drag: none;

  margin-bottom: 32px;
`;

const Title = styled(TX.Headline2)`
  margin-bottom: 32px;
`;

const LinkButtonWrapper = styled(Link)`
  display: flex;

  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

export default NotFound;
